// extracted by mini-css-extract-plugin
module.exports = {"companyStats":"companyStats-module--companyStats--1jLMj","large":"companyStats-module--large--1SLTF"};